import React from 'react';
import { Button } from '@mui/material';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import AspectRatioIcon from '@mui/icons-material/AspectRatio';
import FitScreenIcon from '@mui/icons-material/FitScreen';
import IconButton from '@mui/material/IconButton';

const ZoomToolbar = ({
  onZoomIn,
  onZoomOut,
  onReset,
  onFit,
  onFitCanvas
}) => {
  return (
    <div style={{ display: 'flex', gap: '10px' , alignItems: 'center'}}>


    {/* alignItems: 'center', borderColor: 'rgba(255, 0, 68, 0)', backgroundColor: '#ffffffff', padding: '10px', borderRadius: '3px', borderWidth: '2px' }}> */}

      <Button onClick={onZoomOut}
        variant='outlined'
        title="Zoom Out"
        startIcon={<ZoomOutIcon />}
      />
      <Button onClick={onZoomIn}
        variant='outlined'
        title="Zoom In"
        startIcon={<ZoomInIcon />}
      />
      <Button onClick={onReset}
        variant='outlined'
        title="1:1 Zoom"
        startIcon={<AspectRatioIcon />}
      />
      <Button onClick={onFit}
        variant='outlined'
        title="Fit Objects"
        startIcon={<FitScreenIcon />}
      />
      <Button onClick={onFitCanvas}
        variant='outlined'
        title="Fit Canvas"
        startIcon={<FitScreenIcon />}
      />
    </div>
  );
};

export default ZoomToolbar;
